<template>
  <div>
    <div class="common-form">编辑会员套餐</div>
    <el-form ref="form" :model="form" label-width="200px">
      <el-form-item label="会员套餐名称" prop="name" :rules="[{required: true,message: '请输入会员套餐名称'}]">
        <el-input class="max-w460" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="会员套餐原价" prop="marketPrice" :rules="[{required: true,message: '请输入会员套餐原价'}]">
        <el-input class="max-w460" v-model="form.marketPrice" type="number"></el-input>
      </el-form-item>
      <el-form-item label="会员套餐优惠价" prop="price" :rules="[{required: true,message: '请输入会员套餐优惠价'}]">
        <el-input class="max-w460" type="number" v-model="form.price"></el-input>
      </el-form-item>
      <el-form-item label="会员套餐天数(时长/天)" prop="day" :rules="[{required: true,message: '请输入会员套餐天数'}]">
        <el-input class="max-w460" type="number" v-model="form.day"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort" :rules="[{required: true,message: '请输入排序'}]">
        <el-input class="max-w460" v-model="form.sort" type="number"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即添加</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import UserApi from "@/api/user.js";

export default {
  components: {},
  data() {
    return {
      form: {}
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getData();
  },

  methods: {
    // 查询技师详情
    getData() {
      let self = this;
      UserApi.DetailVip(
        {
          id: self.id
        },
        true
      )
        .then(res => {
          // self.loading = false;
          self.form = res.data;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 修改技师
    onSubmit() {
      //
      let self = this;
      UserApi.editVip(self.form, true)
        .then(res => {
          if (res.code == 1) {
            self.$message(res.msg);
          }
          self.$router.push("/user/member/index");
          // self.loading = false;
          console.log(res);
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style scoped lang=''>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/user/member/edit.vue